import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import { emailTemplateSchema } from "../../Validation/Validation";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import CodeEditor from "../../Components/CodeEditor";
import { customStyles } from "../../utils/constant";
import Select from "react-select";

const AddEmailTemplate = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state;
    const [loading, setLoading] = useState(false);
    const editingId = editData?._id;
    const initalvalues = {
        name: editData?.name,
        subject: editData?.subject,
        type: editData?.type,
        cc: editData?.cc,
        to: editData?.to,
        bcc: editData?.bcc,
        content: editData?.content,
        isActive: editData?.isActive || true,
    }

    const { values, errors, handleChange, handleSubmit, setFieldValue, touched } = useFormik({
        initialValues: initalvalues,
        validateOnChange: false,
        validateOnBlur: true,
        enableReinitialize: true,
        validationSchema: emailTemplateSchema,

        onSubmit: async (values) => {
            setLoading(true)

            try {
                const response = editingId ? await axiosInstance.put(`/emailtemplate/updateemailtemplate/${editingId}`, values) : await axiosInstance.post("/emailtemplate/createemailtemplate", values);
                if (response.status === 200) {
                    toast.success(response.data.message)
                    navigator("/email-template")
                }
            } catch (error) {
                toast.error(error.response?.data?.message)
                return error
            } finally {
                setLoading(false)
            }
        }
    })

    const Type = [
        { label: "Customer", value: "Customer" },
        { label: "Admin", value: "Admin" },
    ];

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header">
                    <h3 className="page-title">{editingId ? "Update" : "Add"} Email Template</h3>
                </div>
                <div className="col-md-12 ">
                    <div className="card">
                        <div className="card-body">
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputUsername2" className="col-form-label ">
                                                Email Template Name
                                            </label>
                                            <input
                                                type="text"
                                                className={`border border-dark form-control form-control-sm `}
                                                id="name"
                                                name="name"
                                                placeholder="Enter email template name"
                                                value={values.name}
                                                onChange={handleChange}
                                                readOnly={!!editingId}
                                            />
                                            {touched.name && errors.name && (
                                                <small className="text-danger">{errors.name}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-12 col-md-4">
                                        <div className="form-group">
                                            <label htmlFor="gallery-title" className="col-form-label">Type</label>
                                            <Select
                                                placeholder="Select Type"
                                                options={Type}
                                                styles={customStyles}
                                                value={
                                                    Type.find(
                                                        (opt) => opt.value === values.type
                                                    ) || null
                                                }
                                                onChange={(option) => {
                                                    setFieldValue("type", option?.value || "");

                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputUsername2" className="col-form-label ">
                                                Subject
                                            </label>
                                            <input
                                                type="text"
                                                className={`border border-dark form-control form-control-sm `}
                                                id="subject"
                                                name="subject"
                                                placeholder="Enter email template subject"
                                                value={values.subject}
                                                onChange={handleChange}
                                            />
                                            {touched.subject && errors.subject && (
                                                <small className="text-danger">{errors.subject}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputUsername2" className="col-form-label ">
                                                TO
                                            </label>
                                            <input
                                                type="email"
                                                className={`border border-dark form-control form-control-sm `}
                                                id="to"
                                                name="to"
                                                placeholder="Enter email template to"
                                                value={values.to}
                                                onChange={handleChange}
                                            />
                                            {touched.to && errors.to && (
                                                <small className="text-danger">{errors.to}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputUsername2" className="col-form-label ">
                                                CC
                                            </label>
                                            <input
                                                type="email"
                                                className={`border border-dark form-control form-control-sm `}
                                                id="cc"
                                                name="cc"
                                                placeholder="Enter email template cc"
                                                value={values.cc}
                                                onChange={handleChange}
                                            />
                                            {touched.cc && errors.cc && (
                                                <small className="text-danger">{errors.cc}</small>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label htmlFor="exampleInputUsername2" className="col-form-label ">
                                                BCC
                                            </label>
                                            <input
                                                type="email"
                                                className={`border border-dark form-control form-control-sm `}
                                                id="bcc"
                                                name="bcc"
                                                placeholder="Enter email template bcc"
                                                value={values.bcc}
                                                onChange={handleChange}
                                            />
                                            {touched.bcc && errors.bcc && (
                                                <small className="text-danger">{errors.bcc}</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="mb-3">
                                            <label className="form-label fw-semibold">
                                                Content
                                            </label>
                                            <CodeEditor
                                                value={values.content}
                                                onChange={(v) => setFieldValue("content", v)}
                                                style={{ minHeight: "auto" }}
                                            />
                                            {touched.content && errors.content && (
                                                <small className="text-danger">{errors.content}</small>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-md-12 mt-4 " >
                                        <SwitchToggle
                                            checked={values.isActive}
                                            onChange={(val) =>
                                                setFieldValue("isActive", val)
                                            }
                                        />
                                    </div>
                                </div>


                                <div className="text-center mt-4">
                                    <Button type="submit" color="primary" disabled={loading}>
                                        {loading ? (
                                            <span className="d-inline-flex align-items-center gap-2">
                                                <span
                                                    className="spinner-border spinner-border-sm"
                                                    role="status"
                                                    aria-hidden="true"
                                                ></span>
                                                Processing...
                                            </span>
                                        ) : (
                                            "Save"
                                        )}
                                    </Button>



                                    <Link to="/email-template">
                                        <Button color="danger mx-2">Cancel </Button>
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddEmailTemplate
